/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {ResourceAccess} from './ResourceAccess';
import {
  ResourceAccessFromJSON,
  ResourceAccessFromJSONTyped,
  ResourceAccessToJSON
} from './ResourceAccess';

/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   * @type {string}
   * @memberof User
   */
  id: string;
  /**
   *
   * @type {Array<string>}
   * @memberof User
   */
  roles: Array<string>;
  /**
   *
   * @type {string}
   * @memberof User
   */
  preferredUsername: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  name: string | null;
  /**
   *
   * @type {string}
   * @memberof User
   */
  email: string | null;
  /**
   *
   * @type {{ [key: string]: ResourceAccess; }}
   * @memberof User
   */
  resourceAccess: {[key: string]: ResourceAccess} | null;
  /**
   *
   * @type {Set<string>}
   * @memberof User
   */
  readonly permissions: Set<string>;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  readonly hasAnyProjectAccess: boolean;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  readonly hasAllProjectAccess: boolean;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  readonly hasProjectOilAccess: boolean;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  readonly hasProjectTechprocessAccess: boolean;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  readonly hasApiAccess: boolean;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  readonly hasRndApiAccess: boolean;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  readonly hasDevAccess: boolean;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('roles' in value) || value['roles'] === undefined) return false;
  if (!('preferredUsername' in value) || value['preferredUsername'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('email' in value) || value['email'] === undefined) return false;
  if (!('resourceAccess' in value) || value['resourceAccess'] === undefined) return false;
  if (!('permissions' in value) || value['permissions'] === undefined) return false;
  if (!('hasAnyProjectAccess' in value) || value['hasAnyProjectAccess'] === undefined) return false;
  if (!('hasAllProjectAccess' in value) || value['hasAllProjectAccess'] === undefined) return false;
  if (!('hasProjectOilAccess' in value) || value['hasProjectOilAccess'] === undefined) return false;
  if (
    !('hasProjectTechprocessAccess' in value) ||
    value['hasProjectTechprocessAccess'] === undefined
  )
    return false;
  if (!('hasApiAccess' in value) || value['hasApiAccess'] === undefined) return false;
  if (!('hasRndApiAccess' in value) || value['hasRndApiAccess'] === undefined) return false;
  if (!('hasDevAccess' in value) || value['hasDevAccess'] === undefined) return false;
  return true;
}

export function UserFromJSON(json: any): User {
  return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    roles: json['roles'],
    preferredUsername: json['preferred_username'],
    name: json['name'],
    email: json['email'],
    resourceAccess:
      json['resource_access'] == null
        ? null
        : mapValues(json['resource_access'], ResourceAccessFromJSON),
    permissions: json['permissions'],
    hasAnyProjectAccess: json['has_any_project_access'],
    hasAllProjectAccess: json['has_all_project_access'],
    hasProjectOilAccess: json['has_project_oil_access'],
    hasProjectTechprocessAccess: json['has_project_techprocess_access'],
    hasApiAccess: json['has_api_access'],
    hasRndApiAccess: json['has_rnd_api_access'],
    hasDevAccess: json['has_dev_access']
  };
}

export function UserToJSON(
  value?: Omit<
    User,
    | 'permissions'
    | 'has_any_project_access'
    | 'has_all_project_access'
    | 'has_project_oil_access'
    | 'has_project_techprocess_access'
    | 'has_api_access'
    | 'has_rnd_api_access'
    | 'has_dev_access'
  > | null
): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    roles: value['roles'],
    preferred_username: value['preferredUsername'],
    name: value['name'],
    email: value['email'],
    resource_access:
      value['resourceAccess'] == null
        ? null
        : mapValues(value['resourceAccess'], ResourceAccessToJSON)
  };
}
